import React from "react";
import clsx from "clsx";
import { PreviewStatusPillProps } from "interfaces/preview.interface";
import "./preview_status_pill.component.scss";

const PreviewStatusPill = (props: PreviewStatusPillProps): React.ReactElement => {
    const { label, isLive = false } = props;

    return (
        <span className={clsx("preview_status_pill", isLive && "preview_status_pill_live")}>
            <span className="preview_status_pill_dot" aria-hidden="true" />
            {label}
        </span>
    );
};

export default PreviewStatusPill;
